import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, } from "react";
import { Field } from "formik";
import { TextArea } from "../atoms/TextualInput";
import { FieldError } from "../atoms/field-error";
import { FloatingFieldLabel } from "../atoms/FloatingFieldLabel";
import { FieldBorder } from "../atoms/FieldBorder";
import { LockIcon } from "../atoms/LockIcon";
import { Label } from "../atoms/Label";
import { isInvalid } from "../formHelpers";
import { useDebounce } from "../../hooks/useDebounce";
import { ClearButton, TextAreaWrapper } from "./styles";
/**
 * A formik field for text area input.
 *
 * @param {TextareaFieldProps} props The props for the component.
 * @returns {JSX.Element} The rendered text area field component.
 */
export const TextAreaField = ({ name, disabled, label, autoResize, placeholder, FormField, ...props }) => {
    const [focused, setFocused] = useState(false);
    const [innerValue, setInnerValue, handleOnChange] = useDebounce(name);
    const resizeTextArea = (e) => {
        e.currentTarget.style.height = `${e.currentTarget.scrollHeight}px`;
    };
    return (_jsx(FormField, { name: name, children: ({ field, form }) => (_jsxs(Label, { children: [_jsx(FloatingFieldLabel, { visible: Boolean(innerValue), children: label }), _jsxs(TextAreaWrapper, { children: [_jsx(TextArea, { ...field, ...props, value: innerValue || "", placeholder: placeholder || label, disabled: disabled, onBlur: (event) => {
                                setFocused(false);
                                field.onBlur(event);
                            }, onFocus: () => setFocused(true), onKeyUp: autoResize ? resizeTextArea : undefined, onChange: (event) => {
                                handleOnChange(event, form);
                            } }), field.value && !disabled && (_jsx(ClearButton, { onClick: () => {
                                setInnerValue("");
                                form.setFieldValue(name, "");
                            } })), disabled && _jsx(LockIcon, {})] }), _jsx(FieldBorder, { focused: focused, invalid: isInvalid(name, form) }), _jsx(FieldError, { name: name })] })) }));
};
TextAreaField.defaultProps = {
    FormField: Field,
};
